// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-64da37e0]{position:absolute;top:0;bottom:0;left:0;right:0;z-index:10;background-color:hsla(0,0%,98%,.4);display:grid;align-items:center;justify-items:center;place-items:center;align-content:center;grid-template-rows:minmax(0,60%)}.loading[data-v-64da37e0]{height:100%;width:33%;max-width:60px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
